import { FAIcon } from '@/components'
import { format } from '@/utils/date-fns'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'

interface Props {
  startsAt: string
}

/** Marks a thread in the forum list as an event, with the date it happens. */
export const EventBadge: React.FC<Props> = ({ startsAt }) => {
  const translations = useTranslate({ event: 'events.event' })

  return (
    <span className="ml-2 inline-flex items-center gap-1 rounded-full bg-stone-100 px-2 py-0.5 align-middle text-xs font-semibold text-stone-600">
      <FAIcon icon="calendar-star" type="regular" />
      {translations.event}
      <span className="font-normal">{format(new Date(startsAt), 'PP')}</span>
    </span>
  )
}
